import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Box, Text, Button, Menu, Anchor } from 'grommet';
import { Notes, More, Download, Search, Trash, Transaction, Chat, Print } from 'grommet-icons';

import { EmptySearches, Placeholder, ErrorsSearches, Pagination, Tag } from '../../../../components';

import { toggleDetailsLayer } from '../../actions/details';
import { generatePrint } from '../../actions/print';
import { generateCsv } from '../../actions/export-csv';
import { toggleFormChangeStatusLayer } from '../../actions/form-change-status';
import { toggleFormCommentLayer } from '../../actions/form-comment';
import { openFormSearchLayer, goToNextPage, goToPrevPage } from '../../actions/form-search';
import { toggleFormDeleteLayer } from '../../actions/form-delete';

import { mask, formattedDateTime, formattedNumber } from '../../../../utils';
import rulesName from '../../../../constants/rules';

function SearchResult(props) {
  const {
    userLogged: { rules },

    loadingFormSearch,
    dataRows,
    totalOfRows,
    getListError,

    protocolNumber,
    name,
    email,
    telephone,
    statusId,
    page,
    limit,

    toggleDetailsLayer,
    generatePrint,
    generateCsv,
    toggleFormDeleteLayer,
    toggleFormChangeStatusLayer,
    toggleFormCommentLayer,
    openFormSearchLayer,
    goToNextPage,
    goToPrevPage,
  } = props;

  if(loadingFormSearch && !getListError) {
    return (
      <Placeholder
        title='Carregando...'
        message='Aguarde que estamos preparando as coisas :)'
      />
    );
  }

  if(getListError) {
    return <ErrorsSearches
      button={{
        label: 'Abrir filtros',
        action: openFormSearchLayer
      }}
    />;
  }

  if(!dataRows.length) {
    return <EmptySearches
      buttonFilters={{
        label: 'Abrir filtros',
        action: openFormSearchLayer,
      }}
    />;
  }

  const optionsMenu = (row) => {
    const options = [];

    if(rules.includes(rulesName.statusManifestation)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Transaction />
            <Text size='small'>Trocar status</Text>
          </Box>
        ),
        onClick: () => toggleFormChangeStatusLayer(row)
      });
    }

    if(rules.includes(rulesName.statusManifestation)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Chat />
            <Text size='small'>Comentar, Anotar</Text>
          </Box>
        ),
        onClick: () => toggleFormCommentLayer(row)
      });
    }

    if(rules.includes(rulesName.printManifestation)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Print />
            <Text size='small'>Imprimir</Text>
          </Box>
        ),
        onClick: () => generatePrint(row)
      });
    }

    if(rules.includes(rulesName.deleteManifestation)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Trash color='status-error' />
            <Text size='small'>Excluir</Text>
          </Box>
        ),
        onClick: () => toggleFormDeleteLayer(row)
      });
    }

    return options;
  }

  return (
    <ResponsiveContext.Consumer>
      {size => {
        return (
          <Box
            direction='row'
            justify='center'
            margin={{ horizontal: 'medium', top: '80px' }}
          >
            <Box
              pad='small'
              width='xlarge'
            >
              <Box
                align='center'
                direction='row'
                justify='between'
                margin={{ bottom: 'small' }}
              >
                <Box
                  direction={size === 'small' ? 'column' : 'row'}
                  align={size === 'small' ? 'baseline' : 'center'}
                  gap={size === 'small' ? null : 'small'}
                >
                  <Text size='xlarge'>{formattedNumber(totalOfRows)}</Text>

                  <Text
                    size={size === 'small' ? 'xsmall' : 'medium'}
                    color='dark-6'
                  >
                    {totalOfRows > 1 ? 'Manifestações' : 'Manifestação'}
                  </Text>
                </Box>

                <Box direction='row' align='center'>
                  {rules.includes(rulesName.printManifestation) &&
                    <Button
                      title={`Download Excel (.csv) das ${formattedNumber(totalOfRows)} manifestação encontrada`}
                      icon={<Download />}
                      size='small'
                      margin={{ right: 'xsmall' }}
                      onClick={() => {
                        generateCsv({
                          protocolNumber,
                          name,
                          email,
                          telephone,
                          statusId,
                          page: 1,
                          limit: totalOfRows,
                        })
                      }}
                    />
                  }

                  <Button
                    title='Filtrar'
                    icon={<Search />}
                    size='small'
                    onClick={() => { openFormSearchLayer() }}
                  />
                </Box>
              </Box>

              <Box
                direction='row'
                pad={{ vertical: 'medium' }}
                border={{ side: 'bottom', color: 'light-5' }}
                gap='small'
              >
                {size !== 'small' && (
                  <Box width='20vw'>
                    <Text color='dark-2'>Protocolo</Text>
                  </Box>
                )}

                {size !== 'small' && <Box width='30vw'>
                  <Text color='dark-2'>Nome</Text>
                </Box>}

                {size !== 'small' && <Box width='30vw'>
                  <Text color='dark-2'>Telefone</Text>
                </Box>}

                {size !== 'small' && <Box width='30vw'>
                  <Text color='dark-2'>Data de recebimento</Text>
                </Box>}

                {size !== 'small' && size !== 'medium' && (
                  <Box width='30vw'>
                    <Text color='dark-2'>Status</Text>
                  </Box>
                )}

                <Box width='20vw' />
              </Box>

              {dataRows.map(row => {
                const menu = optionsMenu(row);

                return (
                  <Box
                    key={row.id}
                    align='center'
                    direction='row'
                    pad={{ vertical: size === 'small' ? 'small' : 'xsmall' }}
                    border={{ side: 'bottom', color: 'light-5' }}
                    gap='small'
                  >
                    {size !== 'small' && <Box width='20vw'>
                      <Anchor
                        title='Abrir detalhes'
                        label={row.protocolNumber}
                        onClick={() => { toggleDetailsLayer(row) }}
                      />
                    </Box>}

                    {size !== 'small' && <Box width='30vw'>
                      <Text color='dark-2' size='small'>{row.name}</Text>
                    </Box>}

                    <Box width='30vw'>
                      <Text color='dark-2' size='small'>{mask(row.telephone, '(##) ####-#####')}</Text>
                    </Box>

                    <Box width='30vw'>
                      <Text color='dark-2' size='small'>{formattedDateTime(row.createdAt, 'ddd, DD MMM YYYY')}</Text>
                    </Box>

                    {size !== 'small' && size !== 'medium' && (
                      <Box width='30vw' direction='row'>
                        <Tag text={row.statusName} background={row.statusColor} />
                      </Box>
                    )}

                    <Box align='end' width='20vw'>
                      <Box direction='row'>
                        <Button
                          title='Abrir detalhes'
                          icon={<Notes color='dark-3' size='medium' />}
                          onClick={() => { toggleDetailsLayer(row) }}
                        />

                        {menu.length > 0 && (<Menu
                          dropProps={{ align: { right: 'right', top: 'top' } }}
                          icon={<More />}
                          items={menu}
                        />)}
                      </Box>
                    </Box>
                  </Box>
                )
              })}

              <Pagination
                totalOfRows={totalOfRows}
                nextPage={goToNextPage}
                prevPage={goToPrevPage}
                filters={{
                  protocolNumber,
                  name,
                  email,
                  telephone,
                  statusId,
                  page,
                  limit,
                }}
              />
            </Box>
          </Box>
        )
      }}
    </ResponsiveContext.Consumer>
  )
}

const mapStateToProps = ({ authReducer: { authenticated }, manifestationReducer: { searchResult, formSearch } }) => ({
  userLogged: authenticated,

  protocolNumber: formSearch.protocolNumber,
  name: formSearch.name,
  email: formSearch.email,
  telephone: formSearch.telephone,
  statusId: formSearch.statusId,

  page: formSearch.page,
  limit: formSearch.limit,

  loadingFormSearch: searchResult.loadingFormSearch,
  dataRows: searchResult.dataRows,
  totalOfRows: searchResult.totalOfRows,
  getListError: searchResult.getListError,
});

const mapDispatchToProps = dispath => {
  return bindActionCreators({
    toggleDetailsLayer,
    generatePrint,
    generateCsv,
    toggleFormDeleteLayer,
    toggleFormChangeStatusLayer,
    toggleFormCommentLayer,
    openFormSearchLayer,
    goToNextPage,
    goToPrevPage,
  }, dispath)
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResult);
